module.exports = __webpack_public_path__ + "img/hospital5.cad9f456.png";